import { NgOptimizedImage } from '@angular/common';
import { Component, output } from '@angular/core';

import { injectAuthTranslations } from '@core/components-authorization-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DialogFooterComponent,
  DialogBodyComponent,
  HeadingComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-app-activation-step-1',
  templateUrl: './app-activation-step-1.component.html',
  styleUrls: ['./app-activation-step-1.component.less'],
  imports: [
    DialogHeaderComponent,
    HeadingComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    NgOptimizedImage,
  ],
})
export class AppActivationStep1Component {
  public translationKey = injectAuthTranslations();

  public goNext = output<void>();
  public cancel = output<void>();
}
